import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './AddButton.css';

const AddButton = ({ label = '', containerStyle = {}, disabled = false, containerClass = '', onClick = () => {} }) => {
    return (
        <button
            className={`${css.container} ${containerClass}`}
            onClick={onClick}
            style={containerStyle}
            disabled={disabled}
        >
            <Translate id={label} />
        </button>
    );
};

AddButton.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    containerStyle: PropTypes.objectOf(PropTypes.any),
    containerClass: PropTypes.string,
};

export default AddButton;
